:host {
  display: flex;
  justify-content: center;
  align-items: center;
  .icon {
    display: flex;
    color: var(--color-on-primary-container);
    position: absolute;
    left: 32px;
    z-index: 20;
    pointer-events: none;
  }
}

.search-input {
  width: 100%;
  background-color: var(--color-surface-container-high);
  box-shadow: var(--elevation-2);
  border: none;
  border-radius: var(--border-radius, 40px);
  color: var(--color-on-primary-container);
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  font-family: var(--font-family);
  height: 44px;
  padding: 0px 16px 0px 48px;
  outline-color: var(--color-outline);
  &::placeholder {
    color: var(--color-on-primary-container);
  }
  &::-webkit-search-cancel-button {
    -webkit-appearance: none;
    background-color: var(--color-on-primary-container);
    -webkit-mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23777'><path d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'/></svg>");
    background-size: 20px 20px;
    height: 20px;
    width: 20px;
  }
}
